import React, { useMemo } from "react";
import lotusMallShops from "assets/data/lotusMallShops.json";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import lodash from "lodash";
import { plugins, crmValidator } from "helpers";
import {
  buildMinionReceiptList,
  calculateMinionAdjustedPoint,
  calculateMinionEarnPoint,
  calculateMinionSummaryWarnings,
  formatMinionReceiptDate,
  formatMinionReceiptDateForSubmit,
  formatMinionTablePoint,
  getRowBranch,
  getRowProvince,
  getRowReceiptNumber,
  isMinionCurrentReceiptRow,
} from "helpers/minion-earn-warnings";
import { reportActions } from "actions";
import { mylotusActions } from "actions/mylotus.actions";

// import MUIDataTable from "mui-datatables";
// import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

import Dialog from "@material-ui/core/Dialog";
// import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomSelect from "components/CustomSelect/CustomSelect.jsx";
// import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker.jsx";
// import TagsMultiSelect from "components/CustomSelect/TagsMultiSelect.jsx";
// import RichEditor from "components/RichEditor/RichEditor.jsx";
// import CustomCheckbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import CustomRadio from "components/CustomRadio/CustomInputRadio.jsx";
// import Icon from '@material-ui/core/Icon';
import CheckCircle from "@material-ui/icons/CheckCircle";
import Cancel from "@material-ui/icons/Cancel";
import CancelIcon from "@material-ui/icons/Cancel";
import { Field, reduxForm, change } from "redux-form";

import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

// import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.jsx";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

// import Typography from '@material-ui/core/Typography';

// import MTablestyles from "assets/jss/material-dashboard-pro-react/customMTableStyle.jsx";
const moment = require("moment");

const imgStyle = {
  width: "200px",
  height: "200px",
  objectFit: "contain",
  outline: "1px solid #DCDCDC",
};

// const THEME = createMuiTheme({
//     ...MTablestyles,
//     overrides: {
//         ...MTablestyles.overrides,
//         MuiTableCell: {
//             head: {

//                 textAlign: "center",
//                 paddingRight: '24px'

//             },
//             body: {
//                 textAlign: "center",
//                 paddingRight: '24px'
//             }
//         }
//     }
// });

const FORM_NAME = "FORM_EARN_REPORT";

const form_validate = {
  remark: {
    rules: {
      required: true,
    },
    messages: {
      required: "กรุณากรอก",
    },
  },
};

const validate = (values) => {
  const errors = crmValidator.validateByRulesList(form_validate, values);
  return errors;
};

function formatTxnDate(isoString, isHours = false) {
  const dt = new Date(isoString);
  const pad = (n) => n.toString().padStart(2, "0");
  const day = pad(dt.getDate());
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const mon = monthNames[dt.getMonth()];
  const year = dt.getFullYear().toString().slice(-2);

  //
  const hh = pad(dt.getHours());
  const mm = pad(dt.getMinutes());
  const ss = pad(dt.getSeconds());

  return isHours ? `${day}-${mon}-${year} ${hh}:${mm}` : `${day}-${mon}-${year}`;

  // return `${day}-${mon}-${year} ${hh}:${mm}:${ss}`;
}

class EarnReportFormForLotusScratchGame extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      remark: false,
      first: true,
      discount: null,
      pointCal: null,
      selectedRemark: null,
    };
  }

  componentDidUpdate(prevProps) {
    const prevId = lodash.get(prevProps.initialValues, "_id");
    const curId = lodash.get(this.props.initialValues, "_id");
    const opened = !prevProps.formOpen && this.props.formOpen;

    if (opened || prevId !== curId) {
      this.setState({
        first: true,
        remark: this.props.initialValues?.remark === "REJECT", // โหมดโชว์เหตุผลเฉพาะถ้าเดิมเป็น REJECT
        discount: null,
        pointCal: null,
        selectedRemark: this.props.initialValues?.remark ?? null,
      });
      // เคลียร์เหตุผลเก่าใน redux-form
      this.props.dispatch(change(FORM_NAME, "reject_note", undefined));
    }
  }

  closeDialog() {
    const { dispatch } = this.props;
    this.setState({
      discount: null,
      pointCal: null,
    });
    dispatch({ type: "CLOSE_EARN_REPORT_EDIT" });
  }

  async handleSubmit(values) {
    const { dispatch, user, initialValues, earnReport, merchantProjectCode } = this.props;

    if (
      initialValues.remark !== values.remark ||
      initialValues.code !== values.code
    ) {
      if (values.remark == "PENDING") {
        const remark = values.remark;
        const transactionId = values._id;
        const code = values.code;
        const type = values.type;
        let params = {
          remark,
          transactionId,
          code,
          type,
        };

        dispatch(reportActions.updateTransaction(params));
      } else {
        const remark = values.remark;
        const transactionId = values._id;
        const reject_note = values.reject_note;
        const productId = values.productId;
        const code = values.code;
        const type = values.type;
        let params = {};

        if (values.remark == "SUCCESS") {
          let point = this.state.pointCal
            ? parseFloat(this.state.pointCal)
            : lodash.get(this.props.initialValues, "point");
          let discount = this.state.discount
            ? parseFloat(this.state.discount)
            : 0;

          if (merchantProjectCode === "minion") {
            const minionReceiptDate =
              formatMinionReceiptDateForSubmit(
                values.receiptDate || initialValues.receiptDate
              ) || initialValues.receiptDate;
            const receiptListForAdjust = buildMinionReceiptList(
              Array.isArray(initialValues.receiptList)
                ? initialValues.receiptList
                : [],
              {
                receiptDate: minionReceiptDate,
                currentTransaction: {
                  _id: values._id,
                  code: initialValues.code,
                  receiptNumber: initialValues.receiptNumber,
                  receiptDate: minionReceiptDate,
                  branch: initialValues.branch,
                  province: initialValues.province,
                  shop: initialValues.shop,
                  priceSum: initialValues.priceSum,
                  point: initialValues.point,
                  remark: values.remark,
                },
              }
            );
            const adjusted = calculateMinionAdjustedPoint(receiptListForAdjust, {
              transactionId: values._id,
              transactionCode: initialValues.code,
              receiptDate: minionReceiptDate,
              shop: initialValues.shop,
              priceSum: initialValues.priceSum,
              point: initialValues.point,
            });
            point = adjusted.adjustedPoint;
            discount = adjusted.discount;
          }

          params = {
            remark,
            transactionId,
            reject_note,
            point,
            discount,
            code,
            type,
          };

          const rawReceiptDate = values.receiptDate || initialValues.receiptDate;
          if (merchantProjectCode === "minion") {
            const submitReceiptDate =
              formatMinionReceiptDateForSubmit(rawReceiptDate);
            if (submitReceiptDate) {
              params.receiptDate = submitReceiptDate;
            }
          } else if (rawReceiptDate) {
            params.receiptDate = plugins.datetimeFormat(rawReceiptDate, "mongo");
          }
        } else {
          params = {
            remark,
            transactionId,
            reject_note,
            code,
            type
          };
        }

        this.setState({
          discount: null,
          pointCal: null
        });

        // Make sure the containing function (e.g., your form's onSubmit handler) is marked as `async`
        // Example: const onSubmit = async (values) => { ... }

        try {
          const updateRes = await dispatch(
            mylotusActions.updateTransaction(params, merchantProjectCode)
          );

          if (
            updateRes.status === true &&
            updateRes.message === "SUCCESS" &&
            values.remark == "SUCCESS"
          ) {
            const customerId = lodash.get(initialValues, "user.customerId");
            const merchantId = lodash.get(initialValues, "user.merchantId");

            if (merchantProjectCode === "scratchtowin") {
              dispatch(
                mylotusActions.addQuotaScratchGame({ customerId, merchantId })
              );
            } 
            // console.log("addQuotaScratchGame response:", addQuotaRes);
          } else {
            console.error(
              "Update transaction was not successful, skipping addQuotaScratchGame."
            );
          }
        } catch (error) {
          console.error("An error occurred during the process:", error);
        }
      }

      /*  this.setState({ remark: false, first: true, approved_vitamilk: false }) */
    } else if (
      values.remark == "REJECT" &&
      initialValues.reject_note !== values.reject_note
    ) {
      const remark = values.remark;
      const transactionId = values._id;
      const reject_note = values.reject_note;
      const code = values.code;
      let params = {
        remark,
        transactionId,
        reject_note,
        code,
      };

      this.setState({
        discount: null,
        pointCal: null,
      });
      dispatch(reportActions.updateTransaction(params));
    } else {
      this.closeDialog();
    }
    // console.log(pointCal, lodash.get(this.props.initialValues, 'point'), this.state.discount);
  }

  render() {
    const {
      handleSubmit,
      formOpen,
      fromMode,
      classes,
      earnReport,
      tableKey,
      initialValues,
      handleChange,
      merchantProjectCode,
    } = this.props;

    const id = lodash.get(initialValues, "_id");
    const user = lodash.get(initialValues, "user");
    const userFirstName = lodash.get(user, "firstName");
    const userLastName = lodash.get(user, "lastName");
    const userPhoneNumber = lodash.get(user, "phoneNumber");
    const sn_remark = lodash.get(initialValues, "sn_remark");
    const sn_verified = lodash.get(initialValues, "sn_verified");
    const date = lodash.get(initialValues, "date");
    const model = lodash.get(initialValues, "model");
    const code = lodash.get(initialValues, "code");
    const check_id = lodash.get(initialValues, "check_id");
    const store_name = lodash.get(initialValues, "store_name");
    const machine_number = lodash.get(initialValues, "machine_number");
    const price = lodash.get(initialValues, "price");
    const images = lodash.get(initialValues, "images");
    const images_sn = lodash.get(initialValues, "images_sn");
    const images1 = lodash.get(initialValues, "images1");
    const images2 = lodash.get(initialValues, "images2");
    const remark = lodash.get(initialValues, "remark");
    const inputList = lodash.get(initialValues, "inputList");
    const province = lodash.get(initialValues, "province");
    const point = lodash.get(initialValues, "point");
    const shop = lodash.get(initialValues, "shop");
    const priceSum = lodash.get(initialValues, "priceSum");
    const discount = lodash.get(initialValues, "discount");
    const receiptDateRaw = lodash.get(initialValues, "receiptDate");
    const receiptDate =
      merchantProjectCode === "minion"
        ? formatMinionReceiptDateForSubmit(receiptDateRaw) || receiptDateRaw
        : receiptDateRaw;
    const checkDuplicate = lodash.get(initialValues, "checkDuplicate");
    const receiptList = lodash.get(initialValues, "receiptList");
    const type = lodash.get(initialValues, "type");

    let check_reject_note = false;
    if (remark === "REJECT") {
      check_reject_note = true;
    }
    let remarkOptions;
    if (remark === "PENDING") {
      remarkOptions = [
        {
          label: "Pending",
          value: "PENDING"
        },
        {
          label: "Approve",
          value: "SUCCESS"
        },
        {
          label: "Reject",
          value: "REJECT"
        },
      ];
    } else {
      remarkOptions = [
        {
          label: "Approve",
          value: "SUCCESS"
        },
        {
          label: "Reject",
          value: "REJECT"
        },
      ];
    }

    if (sn_remark === "CODE_NOT_FOUND" || sn_remark === "CODE_WAS_USED") {
      remarkOptions = [
        {
          label: "Pending",
          value: "PENDING"
        },
        {
          label: "Reject",
          value: "REJECT"
        },
      ];
    }

    const memberId =
      lodash.get(initialValues, "memberId") ||
      lodash.get(initialValues, "user.customerId");
    const externalId = lodash.get(initialValues, "externalId");
    const rawReceiptList = Array.isArray(receiptList) ? receiptList : [];
    const matchedReceipt =
      rawReceiptList.find((r) => r._id == id || r.transactionId == id) ||
      rawReceiptList.find((r) => r.code == code);
    const branch =
      merchantProjectCode === "minion"
        ? lodash.get(initialValues, "branch") ||
          getRowBranch(matchedReceipt)
        : lodash.get(initialValues, "branch");
    const provinceResolved =
      merchantProjectCode === "minion"
        ? lodash.get(initialValues, "province") ||
          getRowProvince(matchedReceipt)
        : province;
    const receiptNumber =
      merchantProjectCode === "minion"
        ? lodash.get(initialValues, "receiptNumber") ||
          getRowReceiptNumber(matchedReceipt)
        : lodash.get(initialValues, "receiptNumber");
    const currentTransaction = {
      _id: id,
      code,
      receiptNumber,
      receiptDate,
      branch,
      shop,
      province: provinceResolved,
      priceSum,
      point,
      remark,
      status: lodash.get(initialValues, "status"),
      memberId,
      externalId,
    };
    const list =
      merchantProjectCode === "minion"
        ? buildMinionReceiptList(rawReceiptList, {
            receiptDate,
            currentTransaction,
          })
        : rawReceiptList;
    const minionPointAdjustment =
      merchantProjectCode === "minion"
        ? calculateMinionAdjustedPoint(list, {
            transactionId: id,
            transactionCode: code,
            receiptDate,
            shop,
            priceSum,
            point,
          })
        : null;
    const selectedRemark = this.state.selectedRemark ?? remark;
    const pendingPoint =
      this.state.pointCal !== null
        ? this.state.pointCal
        : merchantProjectCode === "minion"
          ? minionPointAdjustment.earnedPoint
          : point;
    const isAboutToApprove =
      remark !== "SUCCESS" &&
      remark !== "REJECT" &&
      (remark === "PENDING" || selectedRemark === "SUCCESS");
    const summaryWarnings =
      merchantProjectCode === "minion"
        ? calculateMinionSummaryWarnings(list, {
            pendingPoint,
            isAboutToApprove,
            transactionId: id,
            transactionCode: code,
            receiptDate,
          })
        : [];

    let imageList = [];
    let imageListSn = [];
    let imageList1 = [];
    let imageList2 = [];

    lodash.forEach(images_sn, function(value, key) {
      imageListSn.push(value.url);
    });

    const showImagesSn = imageListSn.map((item) => (
      <a href={item} target="_blank">
        <div style={{ width: "210px", height: "210px", float: "left" }}>
          <img src={item} style={imgStyle} />
        </div>
      </a>
    ));

    lodash.forEach(images, function(value, key) {
      imageList.push(value.url);
    });
    const showImages = imageList.map((item) => (
      <a href={item} target="_blank">
        <div
          style={{ width: "210px", height: "210px", diplay: "inline-block" }}
        >
          <img src={item} style={imgStyle} />
        </div>
      </a>
    ));

    lodash.forEach(images1, function(value, key) {
      imageList1.push(value.url);
    });
    const showImages1 = imageList1.map((item) => (
      <img src={item} width="300" />
    ));

    lodash.forEach(images2, function(value, key) {
      imageList2.push(value.url);
    });
    const showImages2 = imageList2.map((item) => (
      <img src={item} width="300" />
    ));

    let columns = [
      { name: "skuId", label: "SKU ID" },
      { name: "skuName", label: "SKU NAME" },
      { name: "quantity", label: "Quantity" },
    ];

    let options = {
      serverSide: false,
      count: false,
      page: false,
      rowsPerPage: 100,
      selectableRows: "none",
      print: false,
      download: false,
      filter: false,
      responsive: "scroll",
      rowsPerPageOptions: false,
      search: false,
      pagination: false,
      sort: false,
      sortFilterList: false,
      viewColumns: false,
    };

    // console.log("receiptList:", receiptList);
    // const list = Array.isArray(receiptList) ? receiptList : [];
    // console.log("list:", list);
    // const warnings = calculateWarnings(list);

    return (
      <Dialog
        classes={{
          root: classes.center,
          paper: classes.modal,
        }}
        open={formOpen}
        keepMounted
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
        maxWidth="lg"
        scroll="body"
        disableRestoreFocus={true}
      >
        {imageList.length != 0 && (
          <DialogContent
            id="import-result-detail-dialog"
            // className={classes.modalBody}
            style={{ padding: "100", textAlign: "left" }}
          >
            <h4 className={classes.modalTitle} style={{ textAlign: "left" }}>
              <b>Transaction</b>
            </h4>

            <GridContainer spacing={4}>
              <GridItem xs={12}>
                <h5>
                  <b>ใบกำกับภาษี</b>{" "}
                </h5>
                <div
                  style={{
                    display: "flex", // ใช้ flexbox
                    flexDirection: "row", // แนวนอน
                    flexWrap: "wrap", // ถ้ามากกว่า 1 แถว ให้ขึ้นบรรทัดใหม่
                    gap: "10px", // ระยะห่างระหว่างรูป
                  }}
                >
                  {showImages}
                </div>
              </GridItem>
              {/* <GridItem xs={8}>
                            <h5><b>Serial number</b></h5>
                            <div>{showImagesSn}</div>
                        </GridItem> */}
            </GridContainer>
            <br />
            <GridContainer spacing={1}>
              <GridItem xs={2}>
                {model && (
                  <div>
                    <h5>
                      <b>Model</b>
                    </h5>
                    <div style={{ display: "inline-flex" }}>
                      <div style={{ float: "left" }}>{model}</div>
                      <CheckCircle
                        style={{ marginLeft: "5px", color: "#79BF00" }}
                      />
                    </div>
                  </div>
                )}

                {typeof checkDuplicate !== "undefined" && checkDuplicate.length != 0 ? (
                  <h5 style={{ color: "#f44336" }}>
                    <b>
                      เลขที่ใบเสร็จ/ใบกำกับภาษี{" "}
                      <CancelIcon
                        style={{ position: "absolute", marginLeft: "7px" }}
                      />
                    </b>
                  </h5>
                ) : (
                  <h5>
                    <b>เลขที่ใบเสร็จ/ใบกำกับภาษี</b>
                  </h5>
                )}

                <div>
                  {typeof receiptNumber !== "undefined" ? receiptNumber : "-"}
                </div>

                <h5>
                  <b>Serial number</b>
                </h5>
                {sn_verified !== undefined ? (
                  <div style={{ display: "inline-flex" }}>
                    <div style={{ float: "left" }}>{code}</div>
                    {sn_verified ? (
                      <CheckCircle
                        style={{ marginLeft: "5px", color: "#79BF00" }}
                      />
                    ) : (
                      <Cancel style={{ marginLeft: "5px", color: "#dc3545" }} />
                    )}
                    <div style={{ marginLeft: "5px" }}>
                      {sn_remark === "CODE_NOT_FOUND"
                        ? "(รหัสผิด)"
                        : sn_remark === "CODE_WAS_USED"
                        ? "(รหัสซ้ำ)"
                        : null}
                    </div>
                  </div>
                ) : (
                  <div style={{ display: "inline-flex" }}>
                    <div style={{ float: "left" }}>{code}</div>
                  </div>
                )}

                <h5>
                  <b>Province</b>
                </h5>
                <div>
                  {province !== null && province !== "" ? province : "-"}
                </div>

                <h5>
                  <b>Shop</b>
                </h5>
                <div>{shop}</div>

                {type === "receipt-point" && (
                  <>
                    <hr />
                    <h5>
                      <b>ยอดซื้อสินค้า (บาท)</b>
                    </h5>
                    <div>
                      {Number(priceSum).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) || 0}
                    </div>

                    <h5>
                      <b>Point ที่จะได้รับ</b>
                    </h5>
                    <div>
                      {merchantProjectCode === "minion"
                        ? formatMinionTablePoint(currentTransaction, list)
                        : point}
                    </div>
                    {merchantProjectCode === "minion" &&
                      minionPointAdjustment.isReduced && (
                        <>
                          <h5>
                            <b>ส่วนลด (Quota)</b>
                          </h5>
                          <div>{minionPointAdjustment.discount}</div>
                        </>
                      )}
                    <hr />
                  </>
                )}

                {type == "lucky-draw" && (
                  <>
                    <h5>
                      <b>ยอดซื้อสินค้า (บาท)</b>
                    </h5>
                    <div>
                      {Number(priceSum).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) || 0}
                    </div>
                  </>
                )}
              </GridItem>

              {typeof checkDuplicate !== "undefined" &&
              checkDuplicate.length != 0 ? (
                <GridItem xs={8}>
                  <h5>
                    <b>เลขที่ใบเสร็จ/ใบกำกับภาษี ซ้ำ</b>
                  </h5>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Serial number</TableCell>
                        <TableCell>Status</TableCell>
                        {/* <TableCell>Shop</TableCell>
                                                <TableCell>Province</TableCell>
                                                <TableCell>Image</TableCell> */}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {checkDuplicate.map((item) => (
                        <TableRow>
                          <TableCell>{item.code}</TableCell>
                          <TableCell>
                            {item.remark === "SUCCESS" ? (
                              <b
                                style={{ marginLeft: "5px", color: "#79BF00" }}
                              >
                                {item.remark}
                              </b>
                            ) : item.remark === "REJECT" ? (
                              <b
                                style={{ marginLeft: "5px", color: "#f44336" }}
                              >
                                {item.remark}
                              </b>
                            ) : (
                              <b>{item.remark}</b>
                            )}
                          </TableCell>
                          {/* <TableCell>{item.shop}</TableCell>
                                                    <TableCell>{item.province}</TableCell>
                                                    <TableCell>
                                                        <a href={item.images[0].url} target="_blank">
                                                            <div style={{ width: '210px', height: '210px', float: 'left' }}>
                                                                <img src={item.images[0].url} style={imgStyle} />
                                                            </div>
                                                        </a>
                                                    </TableCell> */}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </GridItem>
              ) : (
                ""
              )}

              <GridItem xs={8}>
                {merchantProjectCode === "minion" && list.length > 0 ? (
                  <>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Receipt Number</TableCell>
                          <TableCell>Receipt Date</TableCell>
                          <TableCell>Branch</TableCell>
                          <TableCell>Shop</TableCell>
                          <TableCell>Province</TableCell>
                          <TableCell>Price</TableCell>
                          <TableCell>Point</TableCell>
                          <TableCell>Status</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {list.map((item) => {
                          const isCurrentRow = isMinionCurrentReceiptRow(item, {
                            transactionId: id,
                            transactionCode: code,
                          });
                          const currentRowStyle = isCurrentRow
                            ? { fontWeight: "bold", backgroundColor: "#f5f5f5" }
                            : {};

                          return (
                          <TableRow
                            key={item.code || item._id}
                            style={currentRowStyle}
                          >
                            <TableCell>{getRowReceiptNumber(item) || "-"}</TableCell>
                            <TableCell>
                              {item.receiptDate &&
                                formatMinionReceiptDate(item.receiptDate)}
                            </TableCell>
                            <TableCell>{getRowBranch(item) || "-"}</TableCell>
                            <TableCell>{item.shop}</TableCell>
                            <TableCell>{getRowProvince(item) || "-"}</TableCell>
                            <TableCell>{item.priceSum}</TableCell>
                            <TableCell>
                              {formatMinionTablePoint(item, list)}
                            </TableCell>
                            <TableCell>
                              {String(item.remark || "").toUpperCase() ===
                              "SUCCESS" ? (
                                <b style={{ color: "#79BF00" }}>{item.remark}</b>
                              ) : String(item.remark || "").toUpperCase() ===
                                "REJECT" ? (
                                <b style={{ color: "#f44336" }}>{item.remark}</b>
                              ) : (
                                <b>{item.remark}</b>
                              )}
                            </TableCell>
                          </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                    {summaryWarnings.length > 0 && (
                      <>
                        <hr />
                        <div style={{ color: "red", marginBottom: 16 }}>
                          <h5>Warning</h5>
                          <ul style={{ margin: 0, paddingLeft: 20 }}>
                            {summaryWarnings.map((msg) => (
                              <li key={msg}>{msg}</li>
                            ))}
                          </ul>
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell>Receipt Number</TableCell>
                          <TableCell>Receipt Date</TableCell>
                          <TableCell>Shop</TableCell>
                          <TableCell>Branch</TableCell>
                          <TableCell>Province</TableCell>
                          <TableCell>Price</TableCell>
                          <TableCell>Point</TableCell>
                          <TableCell>Status</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow key={code}>
                          <TableCell></TableCell>
                          <TableCell>{receiptNumber}</TableCell>
                          <TableCell>
                            {receiptDate &&
                              (merchantProjectCode === "minion"
                                ? formatMinionReceiptDate(receiptDate)
                                : formatTxnDate(receiptDate))}
                          </TableCell>
                          <TableCell>{shop}</TableCell>
                          <TableCell>{branch}</TableCell>
                          <TableCell>{province}</TableCell>
                          <TableCell>{priceSum}</TableCell>
                          <TableCell>
                            {merchantProjectCode === "minion" && remark !== "SUCCESS"
                              ? formatMinionTablePoint(currentTransaction, list)
                              : point}
                          </TableCell>
                          <TableCell>
                            {remark === "SUCCESS" ? (
                              <b style={{ color: "#79BF00" }}>{remark}</b>
                            ) : remark === "REJECT" ? (
                              <b style={{ color: "#f44336" }}>{remark}</b>
                            ) : (
                              <b>{remark}</b>
                            )}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </>
                )}
              </GridItem>

            </GridContainer>
          </DialogContent>
        )}

        {imageList1.length != 0 && imageList2.length != 0 && (
          <DialogContent
            id="import-result-detail-dialog"
            // className={classes.modalBody}
            style={{ padding: "100", textAlign: "left" }}
          >
            <h4 className={classes.modalTitle} style={{ textAlign: "left" }}>
              <b>Transaction</b>
            </h4>

            <h5>
              <b>Installation</b>
            </h5>
            <div>{showImages1}</div>

            <h5>
              <b>Location</b>
            </h5>
            <div>{showImages2}</div>
          </DialogContent>
        )}

        <form
          name={FORM_NAME}
          onSubmit={handleSubmit(this.handleSubmit.bind(this))}
        >
          <DialogContent
            id="earn-report-form-dialog"
            className={classes.modalBody}
          >
            <GridContainer spacing={2}>
              <GridItem xs={4}>
                <h5>
                  <b>สินค้า</b>
                </h5>
                {inputList && (
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>ขนาด</TableCell>
                        <TableCell>จำนวน</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {inputList.map((item) => (
                        <TableRow>
                          <TableCell>{item.itemSize}</TableCell>
                          <TableCell>{item.itemCount}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </GridItem>
              <GridItem xs={6}>
                {inputList && (
                  <>
                    <h5>
                      <b>ราคารวม</b>
                    </h5>
                    <div>
                      <Field
                        name="priceSum"
                        component={CustomInput}
                        type="text"
                        labelText={"ราคารวม"}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        value={priceSum}
                        disabled={true}
                      />
                    </div>

                    <h5>
                      <b>ส่วนลด</b>
                    </h5>
                    <div>
                      {/* <input type="number"
                                className="MuiInputBase-input"
                                max={point}
                                value={this.state.discount !== null  ? this.state.discount : discount}
                                onChange={(e) => {
                                    let val = e.target.value ? e.target.value : 0
                                    let cal = parseFloat(point) - parseFloat(val);
                                    if (cal < 0) {
                                      cal = 0
                                    }

                                    // discount = e.target.value
                                    
                                    this.setState({
                                      discount: e.target.value,
                                      pointCal: cal
                                    })
                                  }}
                                  readOnly={(remark === 'REJECT' || remark === 'SUCCESS' ) ? true : false}
                                /> */}
                      <Field
                        name="discount"
                        component={CustomInput}
                        type="number"
                        labelText={"ส่วนลด"}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        // value={this.state.discount}
                        max={point}
                        className="MuiInputBase-input"
                        value={
                          this.state.discount !== null
                            ? this.state.discount
                            : discount
                        }
                        onChange={(e) => {
                          let val = e.target.value ? e.target.value : 0;
                          let cal = parseFloat(point) - parseFloat(val);
                          if (cal < 0) {
                            cal = 0;
                          }

                          this.setState({
                            discount: e.target.value,
                            pointCal: cal,
                          });
                        }}
                        disabled={
                          remark === "REJECT" || remark === "SUCCESS"
                            ? true
                            : false
                        }
                      />
                    </div>

                    <h5>
                      <b>คะแนน</b>
                    </h5>
                    <div>
                      {/* pointAndDiscount() */}
                      {/* <input type="text"
                                name="pointCal"
                                value={this.state.pointCal !== null ? this.state.pointCal : point}
                                readOnly /> */}
                      <Field
                        name="pointCal"
                        component={CustomInput}
                        type="text"
                        labelText={
                          this.state.pointCal !== null
                            ? this.state.pointCal
                            : point
                        }
                        formControlProps={{
                          fullWidth: true,
                        }}
                        value={
                          this.state.pointCal !== null
                            ? this.state.pointCal
                            : point
                        }
                        onChange={(e) => {
                          let val = e.target.value ? e.target.value : 0;
                          let cal = parseFloat(val);
                          if (cal < 0) {
                            cal = 0;
                          }

                          this.setState({
                            pointCal: parseFloat(val),
                          });
                        }}
                        // disabled={true}
                      />
                    </div>
                  </>
                )}
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={6} sm={4} md={4}>
                <Field
                  name="remark"
                  component={CustomSelect}
                  type="text"
                  labelText="Status"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  disabled={
                    imageList.length != 0 && remark === "SUCCESS" ? true : false
                  }
                  optionsList={remarkOptions}
                  onChange={(e) => {
                    this.setState({
                      remark: e.target.value === "REJECT" ? true : false,
                      first: false,
                      selectedRemark: e.target.value,
                    });
                  }}
                />
              </GridItem>
            </GridContainer>

            {Array.isArray(receiptList) &&
            receiptList.length &&
            ((this.state.first && check_reject_note) ||
              (!this.state.first && this.state.remark)) ? (
              <GridContainer>
                <GridItem xs={6} sm={5} md={5}>
                  <Field
                    name="reject_note"
                    component={CustomRadio}
                    radioLists={[
                      {
                        value: "รูปภาพไม่ชัดเจน/ไม่ครบถ้วน",
                        label: (
                          <span style={{ fontWeight: "300" }}>
                            รูปภาพไม่ชัดเจน/ไม่ครบถ้วน
                          </span>
                        ),
                      },
                      {
                        value: "ข้อมูลที่กรอกและข้อมูลรูปถ่ายไม่ตรงกัน",
                        label: (
                          <span style={{ fontWeight: "300" }}>
                            ข้อมูลที่กรอกและข้อมูลรูปถ่ายไม่ตรงกัน
                          </span>
                        ),
                      },
                      {
                        value: "วันที่ในใบเสร็จไม่อยู่ในระยะเวลากิจกรรม",
                        label: (
                          <span style={{ fontWeight: "300" }}>
                            วันที่ในใบเสร็จไม่อยู่ในระยะเวลากิจกรรม
                          </span>
                        ),
                      },
                      {
                        value: "ใบเสร็จที่แนบมาไม่ได้ออกโดยร้านค้าในโลตัส",
                        label: (
                          <span style={{ fontWeight: "300" }}>
                            ใบเสร็จที่แนบมาไม่ได้ออกโดยร้านค้าในโลตัส
                          </span>
                        ),
                      },
                      {
                        value:
                          "ใบเสร็จร้านค้าต้องเป็นใบเสร็จพิมพ์จากเครื่องพิมพ์เท่านั้น",
                        label: (
                          <span style={{ fontWeight: "300" }}>
                            ใบเสร็จร้านค้าต้องเป็นใบเสร็จพิมพ์จากเครื่องพิมพ์เท่านั้น
                          </span>
                        ),
                      },
                      {
                        value:
                          "ใบเสร็จอยู่ในกลุ่มสินค้า/ร้านค้าที่ไม่ร่วมรายการ",
                        label: (
                          <span style={{ fontWeight: "300" }}>
                            ใบเสร็จอยู่ในกลุ่มสินค้า/ร้านค้าที่ไม่ร่วมรายการ
                          </span>
                        ),
                      },
                      {
                        value: "ลงทะเบียนซ้ำ",
                        label: (
                          <span style={{ fontWeight: "300" }}>
                            ลงทะเบียนซ้ำ
                          </span>
                        ),
                      },
                      {
                        value: "วันนี้ได้รับแสตมป์ครบตามโควต้าที่กำหนดแล้ว",
                        label: (
                          <span style={{ fontWeight: "300" }}>
                            วันนี้ได้รับแสตมป์ครบตามโควต้าที่กำหนดแล้ว
                          </span>
                        ),
                      },
                    ]}
                  />
                </GridItem>
              </GridContainer>
            ) : (
              <>
                {imageList.length != 0 &&
                  this.state.first &&
                  check_reject_note && (
                    <GridContainer>
                      <GridItem xs={6} sm={5} md={5}>
                        <Field
                          name="reject_note"
                          component={CustomRadio}
                          radioLists={[
                            {
                              value: "รูปภาพไม่ชัดเจน/ไม่ครบถ้วน",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  รูปภาพไม่ชัดเจน/ไม่ครบถ้วน
                                </span>
                              ),
                            },
                            {
                              value: "ข้อมูลที่กรอกและข้อมูลรูปถ่ายไม่ตรงกัน",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  ข้อมูลที่กรอกและข้อมูลรูปถ่ายไม่ตรงกัน
                                </span>
                              ),
                            },
                            {
                              value: "วันที่ในใบเสร็จไม่อยู่ในระยะเวลากิจกรรม",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  วันที่ในใบเสร็จไม่อยู่ในระยะเวลากิจกรรม
                                </span>
                              ),
                            },
                            {
                              value: "วันที่ในใบเสร็จและวันที่เลือกไม่ตรงกัน",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  วันที่ในใบเสร็จและวันที่เลือกไม่ตรงกัน
                                </span>
                              ),
                            },
                            {
                              value: "ใบเสร็จที่แนบมาไม่ได้ออกโดยร้านค้าในโลตัส",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  ใบเสร็จที่แนบมาไม่ได้ออกโดยร้านค้าในโลตัส
                                </span>
                              ),
                            },
                            {
                              value:
                                "ใบเสร็จร้านค้าต้องเป็นใบเสร็จพิมพ์จากเครื่องพิมพ์เท่านั้น",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  ใบเสร็จร้านค้าต้องเป็นใบเสร็จพิมพ์จากเครื่องพิมพ์เท่านั้น
                                </span>
                              ),
                            },
                            {
                              value:
                                "ใบเสร็จอยู่ในกลุ่มสินค้า/ร้านค้าที่ไม่ร่วมรายการ",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  ใบเสร็จอยู่ในกลุ่มสินค้า/ร้านค้าที่ไม่ร่วมรายการ
                                </span>
                              ),
                            },
                            {
                              value: "ใบเสร็จร้านค้าไม่ถูกต้อง",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  ใบเสร็จร้านค้าไม่ถูกต้อง
                                </span>
                              ),
                            },
                            {
                              value: "ใบเสร็จไม่ตรงตามเงื่อนไข",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  ใบเสร็จไม่ตรงตามเงื่อนไข
                                </span>
                              ),
                            },
                            {
                              value: "ลงทะเบียนซ้ำ",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  ลงทะเบียนซ้ำ
                                </span>
                              ),
                            },
                            {
                              value: "ใบเสร็จซ้ำ",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  ใบเสร็จซ้ำ
                                </span>
                              ),
                            },
                            {
                              value: "สาขาไม่ตรงตามเงื่อนไข",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  สาขาไม่ตรงตามเงื่อนไข
                                </span>
                              ),
                            },
                          ]}
                        />
                      </GridItem>
                    </GridContainer>
                  )}

                {imageList.length != 0 &&
                  !this.state.first &&
                  this.state.remark && (
                    <GridContainer>
                      <GridItem xs={6} sm={5} md={5}>
                        <Field
                          name="reject_note"
                          component={CustomRadio}
                          radioLists={[
                            {
                              value: "รูปภาพไม่ชัดเจน/ไม่ครบถ้วน",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  รูปภาพไม่ชัดเจน/ไม่ครบถ้วน
                                </span>
                              ),
                            },
                            {
                              value: "ข้อมูลที่กรอกและข้อมูลรูปถ่ายไม่ตรงกัน",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  ข้อมูลที่กรอกและข้อมูลรูปถ่ายไม่ตรงกัน
                                </span>
                              ),
                            },
                            {
                              value: "วันที่ในใบเสร็จไม่อยู่ในระยะเวลากิจกรรม",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  วันที่ในใบเสร็จไม่อยู่ในระยะเวลากิจกรรม
                                </span>
                              ),
                            },
                            {
                              value: "วันที่ในใบเสร็จและวันที่เลือกไม่ตรงกัน",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  วันที่ในใบเสร็จและวันที่เลือกไม่ตรงกัน
                                </span>
                              ),
                            },
                            {
                              value: "ใบเสร็จที่แนบมาไม่ได้ออกโดยร้านค้าในโลตัส",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  ใบเสร็จที่แนบมาไม่ได้ออกโดยร้านค้าในโลตัส
                                </span>
                              ),
                            },
                            {
                              value:
                                "ใบเสร็จร้านค้าต้องเป็นใบเสร็จพิมพ์จากเครื่องพิมพ์เท่านั้น",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  ใบเสร็จร้านค้าต้องเป็นใบเสร็จพิมพ์จากเครื่องพิมพ์เท่านั้น
                                </span>
                              ),
                            },
                            {
                              value:
                                "ใบเสร็จอยู่ในกลุ่มสินค้า/ร้านค้าที่ไม่ร่วมรายการ",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  ใบเสร็จอยู่ในกลุ่มสินค้า/ร้านค้าที่ไม่ร่วมรายการ
                                </span>
                              ),
                            },
                            {
                              value: "ใบเสร็จร้านค้าไม่ถูกต้อง",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  ใบเสร็จร้านค้าไม่ถูกต้อง
                                </span>
                              ),
                            },
                            {
                              value: "ใบเสร็จไม่ตรงตามเงื่อนไข",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  ใบเสร็จไม่ตรงตามเงื่อนไข
                                </span>
                              ),
                            },
                            {
                              value: "ลงทะเบียนซ้ำ",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  ลงทะเบียนซ้ำ
                                </span>
                              ),
                            },
                            {
                              value: "ใบเสร็จซ้ำ",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  ใบเสร็จซ้ำ
                                </span>
                              ),
                            },
                            {
                              value: "สาขาไม่ตรงตามเงื่อนไข",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  สาขาไม่ตรงตามเงื่อนไข
                                </span>
                              ),
                            },
                          ]}
                        />
                      </GridItem>
                    </GridContainer>
                  )}

                {imageList1.length != 0 &&
                  imageList2.length != 0 &&
                  this.state.first &&
                  check_reject_note && (
                    <GridContainer>
                      <GridItem xs={6} sm={5} md={5}>
                        <Field
                          name="reject_note"
                          component={CustomRadio}
                          radioLists={[
                            {
                              value: "รูปภาพการติดตั้งไม่ถูกต้อง",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  รูปภาพการติดตั้งไม่ถูกต้อง
                                </span>
                              ),
                            },
                            {
                              value: "รูปภาพสถานที่ติดตั้งไม่ถูกต้อง",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  รูปภาพสถานที่ติดตั้งไม่ถูกต้อง
                                </span>
                              ),
                            },
                            {
                              value:
                                "รูปภาพไม่ชัดเจน ไม่สามารถตรวจสอบเลข Serial Number ได้",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  รูปภาพไม่ชัดเจน ไม่สามารถตรวจสอบเลข Serial
                                  Number ได้
                                </span>
                              ),
                            },
                            {
                              value: "รูป S/N ไม่ชัดเจน",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  รูป S/N ไม่ชัดเจน
                                </span>
                              ),
                            },
                            {
                              value: "S/N ไม่ถูกต้อง",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  S/N ไม่ถูกต้อง
                                </span>
                              ),
                            },
                            {
                              value: "ข้อมูลที่กรอกและข้อมูลรูปถ่ายไม่ตรงกัน",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  ข้อมูลที่กรอกและข้อมูลรูปถ่ายไม่ตรงกัน
                                </span>
                              ),
                            },
                          ]}
                        />
                      </GridItem>
                    </GridContainer>
                  )}

                {imageList1.length != 0 &&
                  imageList2.length != 0 &&
                  !this.state.first &&
                  this.state.remark && (
                    <GridContainer>
                      <GridItem xs={6} sm={5} md={5}>
                        <Field
                          name="reject_note"
                          component={CustomRadio}
                          radioLists={[
                            {
                              value: "รูปภาพการติดตั้งไม่ถูกต้อง",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  รูปภาพการติดตั้งไม่ถูกต้อง
                                </span>
                              ),
                            },
                            {
                              value: "รูปภาพสถานที่ติดตั้งไม่ถูกต้อง",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  รูปภาพสถานที่ติดตั้งไม่ถูกต้อง
                                </span>
                              ),
                            },
                            {
                              value:
                                "รูปภาพไม่ชัดเจน ไม่สามารถตรวจสอบเลข Serial Number ได้",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  รูปภาพไม่ชัดเจน ไม่สามารถตรวจสอบเลข Serial
                                  Number ได้
                                </span>
                              ),
                            },
                            {
                              value:
                                "รูปภาพที่แนบมาไม่ถูกต้องตามเงื่อนไขที่กำหนด",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  รูปภาพที่แนบมาไม่ถูกต้องตามเงื่อนไขที่กำหนด
                                </span>
                              ),
                            },
                            {
                              value: "ข้อมูลที่กรอกและข้อมูลรูปถ่ายไม่ตรงกัน",
                              label: (
                                <span style={{ fontWeight: "300" }}>
                                  ข้อมูลที่กรอกและข้อมูลรูปถ่ายไม่ตรงกัน
                                </span>
                              ),
                            },
                          ]}
                        />
                      </GridItem>
                    </GridContainer>
                  )}
              </>
            )}
          </DialogContent>

          <DialogActions className={classes.modalFooter}>
            <Button
              id={`${FORM_NAME}_btn_submit`}
              type="submit"
              style={{ marginRight: "10px" }}
              color="primary"
            >
              Submit
            </Button>

            <Button
              id={`${FORM_NAME}_btn_cancel`}
              type="button"
              onClick={() => {
                this.setState({ remark: false, first: true, selectedRemark: null });
                this.closeDialog();
              }}
              color="white"
            >
              Cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}

function mapStateToProps(state) {
  const { formOpen, earnReport, formMode } = state.report;
  const { user } = state.authentication;
  return {
    earnReport,
    formOpen,
    formMode,
    user,
  };
}
const connectedComponent = connect(mapStateToProps)(
  EarnReportFormForLotusScratchGame
);

export default reduxForm({
  form: FORM_NAME,
  validate: validate,
  enableReinitialize: true,
  onSubmitFail: (errors) => {
    //    crmValidator.alertFirstInvalid(FORM_NAME, errors, form_validate);
  },
})(withStyles(sweetAlertStyle)(connectedComponent));
